module.exports = __webpack_public_path__ + "static/media/Mobile_Workshop_COMO_INVESTIR_EM_ACOES_DE_FORMA_SEGURA.a4a0f5a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/acoes/Mobile_Workshop_COMO_INVESTIR_EM_ACOES_DE_FORMA_SEGURA.png
// module id = 75
// module chunks = 0